<template>
  <v-card
    class="mx-auto"
    max-width="1200px"
    style="margin-top:10px;"
  >
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>

      <v-snackbar
      :timeout="3000"
      v-model="snackbar"
      top
      color="warning"
    >
      {{ text }}
    </v-snackbar>
    </v-overlay>
    <v-card-title style="background-color:#006699;color:white" >
      Gerar Quandro de honra
    </v-card-title>
     <v-card-text>
       <v-row>
         <v-col md="12">
            <!-- ============ AREA DE PESQUISA ==================== -->
       <span style="margin-left:10px;margin-top:10px;"><v-chip
       class="ma-2"
      close
      color="primary"
      text-color="white"
     >
      Área de Pesquisa
    </v-chip></span>
            <v-card
             style="margin-left:10px;"
              max-width="1200px"
            >
              <v-card-text class="text--primary">
                 <v-row>
                    <v-col md="3">
                      <label>Anolectivo</label>
                        <v-select
                          v-model="anolectivoSelected"
                          :items="Listaranoslectivo"
                          label="Filtre pelo anolectivo"
                          item-value="descricao"
                          item-text="novadescricao"
                          outlined
                        ></v-select>
                    </v-col>
                    <v-col md="3">
                      <label>Curso</label>
                         <v-combobox
                         :items="cursos"
                         item-text="descricao"
                         v-model="editedItem.curso"
                          label="Selecione o curso"
                          outlined
                          return-object
                        ></v-combobox>
                    </v-col>
                     <v-col md="2">
                     <label>Classe</label>
                         <v-combobox
                         :items="classes"
                         item-text="descricao"
                         v-model="editedItem.classe"
                          label="Selecione a classe"
                          outlined
                          return-object
                        ></v-combobox>
                    </v-col>
                     <v-col md="2">
                     <label>Trimetre</label>
                         <v-combobox
                         :items="trimestres"
                         item-text="descricao"
                         v-model="editedItem.trimestre"
                          label="Selecione o trimestre"
                          outlined
                          return-object
                        ></v-combobox>
                    </v-col>
                    <v-col md="1">
                      <v-btn small @click="Pesquisar()" style="margin-top:20px;" :disabled="editedItem.curso === '' || editedItem.classe === '' || editedItem.trimestre === ''" fab color="primary"><v-icon>search</v-icon></v-btn>
                    </v-col>
                    <v-col md="1">
                      <v-btn small @click="Limpar()" style="margin-top:20px;color:white;" :disabled="!estudantes.length" fab color="green" sty><v-icon>delete</v-icon></v-btn>
                    </v-col>
                 </v-row>
              </v-card-text>
            </v-card>
         </v-col>
         <v-col md="12">
              <!-- ============ AREA Dos dados ==================== -->
            <v-card
             style="margin-left:10px;"
              max-width="1200"
            >
              <v-card-text class="text--primary">
                 <v-row>
                    <v-col md="12">
                      <label>Resultado da pesquisa</label>
                         <v-data-table
                          :headers="headers"
                          :items="estudantes"
                          :search="search"
                        >
                           
                            <template v-slot:item.resultado="{ item }">
                              <span style="color:green;" v-if="item.resultado === 'Transita'">Transita	</span>
                              <span style="color:red;" v-if="item.resultado === 'Não Transita' ||item.resultado === '' ">Não Transita	</span>
                            </template>

                            <template v-slot:item.acao="{ item }">
                               <v-tooltip left>
                                <template v-slot:activator="{ on }">
                                  <v-icon color="green darken-3" v-on="on" size="25" class="mr-2" @click="VisualizarHistorico(item)">receipt</v-icon>
                                </template>
                                <span>Visualizar o histórico académico</span>
                              </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-col>
                 </v-row>
              </v-card-text>
            </v-card>
         </v-col>
       </v-row>
     </v-card-text>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
var ls = require('local-storage')
  export default {
    data () {
      return {
        anolectivoSelected: ls.get('anolectivo'),
        anolectivoActual: ls.get('anolectivo'),
        message1:'',
        instituicoes: [],
        cursos: [],
        Listaranoslectivo:[],
        classes: [{id:1,descricao:'10ª Classe'},{id:2,descricao:'11ª Classe'},{id:3,descricao:'12ª Classe'},{id:4,descricao:'13ª Classe'}],
        trimestres: [{id:1,descricao:'Iº'},{id:2,descricao:'IIº'},{id:3,descricao:'IIIº'}],
        search: '',
        overlay: false,
        snackbar: false,
        text: '',
        editedItem: {
          instituicao:'',
          estudante: '',
          curso:'',
          classe:'',
          trimestre: ''
        },
        editedItemDeafult: {
          instituicao:'',
          estudante: ''
        },
        headers: [
          {
            text: 'Nome',
            align: 'start',
            sortable: false,
            value: 'nome',
          },
          { text: 'Curso', value: 'curso' },
          { text: 'Classe', value: 'classe' },
          { text: 'Anolectivo', value: 'anoLectivo' },
          { text: 'Nota', value: 'media' },
          { text: 'Ação', value: 'acao' },
        ],
        estudantes: [],
      }
    },
    created(){
      this.initialize()
      this.initializeAnosLectivo()
    },
    methods: {
        async initialize (searchInDb) {
        try {
          this.cursos = await axios
            .get('/cursoAll')
            .then(res => res.data)
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          console.log('errrrrrrrrrrrrrrrrrrro' + error)
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      },

      async Pesquisar (){
         try {  
           this.overlay = true
            let item = {editedItem: this.editedItem, anolectivo:this.anolectivoSelected}
            this.estudantes = await axios
          .post('/gerarQuadroHonra', item)
          .then(res => res.data)
          this.estudantes = this.estudantes.sort((a,b)=>{ // Faz o ordenamento das notas , do MAIOR AO MENOR
             return b.media - a.media
          })
         } catch (error) {
           this.overlay = false
           //this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
         } finally{
            this.overlay = false
         }
         
      },

      Limpar () {
        this.estudantes = []
        this.editedItem = this.editedItemDeafult
        this.anolectivoSelected = this.anolectivoActual
      },

      VisualizarHistorico (item) {
      this.$store.state.objaluno = item
      this.$router.push('Quadro-honra-detalhes')
    },
 

    async initializeAnosLectivo () {
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    }

      // async Pesquisar (){
      //    this.overlay = true
      //    this.snackbar = true
      //    this.text = 'Estudante não encontrado'
      //    setTimeout(() => {
      //      this.overlay = false
      //      this.snackbar = false
      //    }, 1000);
      // }
    }
  }
</script>